import React from 'react';
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
import { Paragraph } from "../../../typography/Paragraph";
export var getRuleMarkup = function getRuleMarkup(rule, index) {
  return React.createElement(Paragraph, {
    key: buildKeyFromStrings(rule, index),
    size: "medium"
  }, rule);
};